import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { api, setAdminToken } from '@/lib/api';
import useSEO from '@/lib/useSEO';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { Link } from 'react-router-dom';

export default function AdminLogin() {
    useSEO({ title: 'Studio admin', path: '/admin/login', noindex: true });
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [err, setErr] = useState(null);
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    async function submit(e) {
        e.preventDefault();
        setErr(null);
        setLoading(true);
        try {
            const r = await api.post('/admin/login', { email, password });
            setAdminToken(r.data.token);
            navigate('/admin/orders');
        } catch (e) {
            setErr(e?.response?.data?.detail || 'Login failed.');
        } finally {
            setLoading(false);
        }
    }

    return (
        <div className="min-h-screen bg-[color:var(--paper)] flex flex-col">
            <div className="mx-auto w-full max-w-md px-6 py-12 flex-1 flex flex-col justify-center">
                <Link to="/" className="text-center font-display text-xl text-[color:var(--umber)]">Leiha Martin Art</Link>
                <p className="text-center text-sm text-[color:var(--muted-fg)] mt-2">Studio admin</p>
                <form onSubmit={submit} className="mt-10 rounded-2xl bg-[color:var(--paper-2)] border border-[color:var(--border)] p-6 space-y-4" data-testid="admin-login-form">
                    {err && (
                        <Alert className="border-[color:var(--border)] bg-[color:var(--paper)]" data-testid="admin-login-error">
                            <AlertDescription className="text-sm text-[color:var(--danger,#B42318)]">{err}</AlertDescription>
                        </Alert>
                    )}
                    <div>
                        <Label htmlFor="adm-email">Email</Label>
                        <Input id="adm-email" type="email" value={email} onChange={(e) => setEmail(e.target.value)} required data-testid="admin-login-email" className="mt-1 bg-[color:var(--paper)] border-[color:var(--border)]" />
                    </div>
                    <div>
                        <Label htmlFor="adm-pass">Password</Label>
                        <Input id="adm-pass" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required data-testid="admin-login-password" className="mt-1 bg-[color:var(--paper)] border-[color:var(--border)]" />
                    </div>
                    <Button type="submit" disabled={loading} data-testid="admin-login-submit-button" className="w-full rounded-xl bg-[color:var(--umber)] text-[color:var(--paper)] hover:bg-[color:var(--ink)]">
                        {loading ? 'Signing in…' : 'Sign in'}
                    </Button>
                </form>
                <p className="text-center text-xs text-[color:var(--muted-fg)] mt-6">Authorised access only.</p>
            </div>
        </div>
    );
}
